import { HTMLAttributes } from 'react';

export enum AScrimIntensity {
  /** Fully transparent — `--t-color-scrim-0`. */
  None = 'None',
  /** Default scrim intensity — `--t-color-scrim-100` (rgba(0,0,0,0.54)). */
  Full = 'Full',
}

export interface AScrimProps extends Omit<HTMLAttributes<HTMLDivElement>, 'aria-hidden' | 'role'> {
  /**
   * Intensity of the solid scrim overlay. Defaults to `Full`
   * (`--t-color-scrim-100`).
   */
  intensity?: AScrimIntensity;
}
